import { App } from 'antd'
import { Outlet } from 'react-router-dom'
import NavbarComponent from '../components/Navbar'
import LanguageSwitch from '../components/LanguageSwitch'

export default function ContestantsLayout() {
    return (
        <App className="relative z-10 box-border select-text pt-20 text-white">
            <header className="fixed left-0 top-0 z-40 flex h-16 w-full items-center justify-between bg-black px-12 text-white lg:px-56">
                <h1 className="text-2xl leading-none" style={{ fontFamily: 'Conthrax' }}>
                    ESC.<span className="text-lg">2023</span>
                </h1>
                <div className="flex items-center gap-3">
                    <LanguageSwitch />
                    <NavbarComponent />
                </div>
            </header>
            <div className="h-[calc(100vh-5rem)] px-12 pb-3 lg:px-56">
                <Outlet />
            </div>
        </App>
    )
}
